<template>
  <div class="masters-qualifications-info">
    <!-- link should also not be part of this module -->
    <div class="cta">
      <a href="javascript:void(0)" @click="showModal" data-qe-id="qualification-info-link">
        {{ $t('masterQualification.main.link', { realPrize }) }}
      </a>
    </div>
    <slot name="activator"></slot>
    <gd-modal
      v-if="showQualificationInfoModal"
      @closeBG="showQualificationInfoModal = false"
      @closeESC="showQualificationInfoModal = false"
      @close="showQualificationInfoModal = false"
    >
      <modal-app l data-qe-id="qualification-info-modal">
        <modal-layout>
          <modal-content>
            <div main>
              <div class="header">
                <div class="trophy"></div>
                <div class="content" v-html="text('final')"></div>
              </div>
              <div class="main-content">
                <div class="row">
                  <div class="ticket-seats arrow-box">
                    <t-text class="master-box arrow centered" v-html="text('qualificationFinal')"></t-text>
                  </div>
                  <div class="score-seats arrow-box">
                    <t-text class="master-box arrow centered" v-html="text('rankingListFinal')"></t-text>
                  </div>
                </div>
                <div class="row">
                  <div class="ranking-list arrow-box one-4th"></div>
                  <div class="ranking-list arrow-box three-4th">
                    <t-text class="master-box" v-html="text('rankingList')"></t-text>
                  </div>
                </div>
                <div class="qualification arrow-box">
                  <div class="master-box">
                    <div class="arrow-extension-box"></div>
                    <t-text v-html="text('masterDetails')"></t-text>
                  </div>
                </div>
                <div class="entry-fee arrow-box">
                  <t-text class="master-box" v-html="text('entryFee')"></t-text>
                </div>
              </div>
            </div>
            <div class="wildcard-content">
              <t-toggle-box :title="$t('masterQualification.wildcard.title')">
                <t-text v-html="infoText"></t-text>
              </t-toggle-box>
            </div>
          </modal-content>
        </modal-layout>
      </modal-app>
    </gd-modal>
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { gdcConverter } from '@gd/currency-converter'
import { marked } from 'marked'
import { ACTION } from '@gd/tracking'
import { track } from '@/lib/track'

const route = useRoute()
const { t } = useI18n()
const showQualificationInfoModal = ref(false)
const realPrize = computed(() => {
  // Format value only with EUR !!!
  return gdcConverter('125000', { gdc: 'EUR' })
})
const infoText = computed(() => {
  return marked(t('masterQualification.wildcard.text'))
})

function showModal() {
  track({
    id: 'master-qualification-modal',
    path: route.fullPath,
    action: ACTION.show,
  })
  showQualificationInfoModal.value = true
}

function text(key: string) {
  return marked(
    t('masterQualification.diagram.' + key, {
      numberOfTournaments: 45,
      finalPrize: realPrize.value,
      firstPrize: gdcConverter('25000', { gdc: 'EUR' }),
      rankPrize: gdcConverter('10000', { gdc: 'EUR' }),
      topRankSeatsNumber: 30,
      topRankPrizesNumber: 100,
      topMasterSeatsNumber: 3,
      topMasterPrizesNumber: 300,
      qualificationNumber: 135,
      maxPrize: gdcConverter('270000', { gdc: 'EUR' }),
      tournamentPrizePool: gdcConverter('6000', { gdc: 'EUR' }),
      entryFee: gdcConverter('10', { gdc: 'EUR' }),
      tournamentTickets: 3,
      calculatedGames: 6,
    })
  )
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import '~@npm/@gd/common-styles/lib/color-vars';
@import '../styles/vars';

.masters-qualifications-info {
  .cta {
    text-align: center;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin-top: 0;
    margin-bottom: 0;
  }
  .modal-app {
    max-width: 700px;
    min-width: 600px;
    background: @c0-a;
  }
  .modal-layout {
    padding: 0;
  }
  .modal-actions {
    margin-top: 1.875em;
  }
  .centered {
    text-align: center;
  }
  .header {
    display: flex;
    color: @c0-a;
    border-bottom: 4px solid;
    border-image: linear-gradient(to right, rgb(240, 234, 149) 0%, rgb(240, 235, 156) 65%, rgb(220, 196, 103) 120%) 0 0
      100%;
    box-shadow: 0 0em 0.5em rgba(0, 0, 0, 0.5);
    background: @colorScheme--midGreen url('../assets/skatmasters/skat_bg.jpg');
    z-index: 2;
    .trophy {
      position: relative;
      width: 16.875rem;
      height: 10rem;
      background: url('../assets/skatmasters/skatmasters_infographic_header_gradient.png') right center no-repeat;
      // background-size: contain;
      &:after {
        content: '';
        position: absolute;
        bottom: -1rem;
        left: 50%;
        transform: translateX(-50%);
        width: 8.375rem;
        height: 10.625rem;
        background: url('../assets/skatmasters/trophy.png') top left no-repeat;
        background-size: contain;
      }
    }
    .content {
      margin: @smallerspacing 2.625rem;
      text-align: left;
      h2 {
        position: relative;
        font-size: 1.625rem;
        font-weight: 700;
        &:before {
          content: '1';
          position: absolute;
          top: -0.3125em;
          left: -2em;
          width: 3.875rem;
          height: 3.875rem;
          display: flex;
          justify-content: center;
          align-items: center;
          color: @c0;
          font-size: 2.625rem;
          font-weight: 600;
          background: url(../assets/game-overview/slot_badge.svg) no-repeat;
          filter: drop-shadow(0 0.1em 0.1em rgba(0, 0, 0, 0.3));
          z-index: 0;
        }
      }
      p {
        color: @c1-c;
        font-size: 1.25em;
        font-weight: 700;
      }
      ul {
        line-height: 1.4em;
        display: block;
        list-style-type: disc;
        margin-left: 1.25em;
        padding-left: 0em;
        li {
          padding-left: 0em;
        }
      }
    }
  }
  .main-content {
    padding: 0 2em;
  }
  .row {
    display: flex;
    > * {
      display: flex;
      flex-direction: column;
      align-content: space-around;
      justify-content: space-between;
      flex-grow: 1;
    }
  }
  .arrow-box {
    position: relative;
    flex-grow: 1;
    padding: 0.625rem 1em 0 1em;
    align-items: stretch;
    &:before {
      content: ' ';
      position: absolute;
      left: 50%;
      border-left: 25px solid transparent;
      border-right: 25px solid transparent;
      border-bottom: 20px solid @colorScheme--midGreen;
      width: 0;
      height: 0;
      transform: translateX(-50%);
      z-index: 2;
      top: -20px;
    }
    &:after {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      content: ' ';
      width: 2.25rem;
      background-color: @colorScheme--midGreen;
      height: 99%;
      z-index: 1;
      top: 0;
    }

    &.ticket-seats {
      flex: 1 1;
      padding-right: 0.312em;
      .master-box {
        display: flex;
        align-items: center;
      }
      &:before,
      &:after {
        left: 68%;
        transform: translateX(-50%);
      }
    }

    &.score-seats {
      flex: 1 1;
      padding-left: 0.312em;
      .master-box {
        display: flex;
        align-items: center;
      }
      &:before,
      &:after {
        left: 32%;
        transform: translateX(-50%);
      }
    }

    &.ranking-list {
      &.one-4th {
        width: 25%;
        margin-bottom: -1em;
        &:before,
        &:after {
          left: 4em;
          transform: translateX(-50%);
        }
      }
      &.three-4th {
        width: 130%;
        &:before,
        &:after {
          left: 59.2%;
          transform: translateX(-50%);
        }
      }
    }
    &.qualification {
      &:before,
      &:after {
        left: 66.5%;
        transform: translateX(-50%);
      }
      .master-box {
        display: flex;
        .arrow-extension-box {
          width: 8.875rem;
          margin-right: -5.625rem;
          &:before {
            display: inline-block;
            content: ' ';
            margin-top: -1.6875rem;
            margin-left: 1.3125rem;
            width: 1.5rem;
            height: 8.8125rem;
            border-bottom: 3px solid @colorScheme--midGreen;
            border-left: 3px solid @colorScheme--midGreen;
          }
        }
      }
    }
    &.entry-fee {
      .master-box {
        border-top-color: transparent;
        padding: 0;
        color: white;
        font-size: 1.25rem;
        font-weight: 700;
        text-align: center;
        background: @colorScheme--midGreen url('../assets/skatmasters/skatmasters_infographic_decoCards.png') right
          bottom no-repeat;
        p {
          margin-top: 0.5em;
          margin-bottom: 0.5em;
          padding: 0 @smallerspacing;
        }
      }
    }
  }
  // layout from the boxes
  .master-box {
    position: relative;
    margin: 0;
    border: 1px solid @c0-b;
    padding: 1.5rem;
    background: white;
    z-index: 2;
    height: 100%;
    p {
      margin: 0.125rem auto 0.375em;
    }
  }
  // collapsible wildcard content
  .wildcard-content {
    padding: @smallerspacing 3em;
    text-align: left;
    .body {
      margin-bottom: 0;
    }
    .body-in-border {
      padding: 2.2em @smallerspacing @smallerspacing !important;
    }
    .body-in {
      padding-bottom: 0 !important;
    }
  }
  // is used by text to show the wildcard * in header
  .asterisk {
    font-weight: normal;
    font-size: 0.77em;
    line-height: normal;
  }
  .close-button {
    margin-bottom: 1.875em;
  }
}
</style>
